import { ObjectModel, Product } from '@types';
import { modelBelongsToProduct } from './model-belongs-to-product';

export const findProductByModel = (products: Product[], model: ObjectModel) =>
    products.find(product => modelBelongsToProduct(product, model));
